import {Dates, Translations} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
export class AccountingReportProController {
  constructor(proService) {
    this.proService = proService;
    this.selectionDataReader = {
      read: (target, ruleSet, arr, message) => {
        const items = this.odataController.selectedItems;
        let counter = 0;
        const next = () => {
          if (counter === items.length) {
            return Promise.resolve();
          }
          const item = items[counter++];
          return this.download(item, target, ruleSet, message).then((data) => {
            if (data) {
              arr.push(data);
            }
            return next();
          });
        };
        return next().then(() => {
          return Promise.resolve();
        });
      },
      exportLabel: Translations.get("SALAXY.NG1.AccountingReportToolsComponent.exportLabel"),
      disabled: () => !this.odataController.selectedItems || this.odataController.selectedItems.length === 0
    };
    this.logicalDate = Dates.format(Dates.add("today", -1, "month"), "YYYY-MM-01");
    this.baseUrl = "/v03/api/files";
    this.getODataFilter = () => {
      return `entityType eq 'MonthlyReport.MonthlyAccounting' and logicalDate eq ${this.logicalDate}`;
    };
    this.getItemDataReader = (item) => {
      return {
        read: (target, ruleSet, arr, message) => {
          item.isReading = true;
          return this.download(item, target, ruleSet, message).then((data) => {
            if (data) {
              arr.push(data);
            }
            item.isReading = false;
            return Promise.resolve();
          });
        },
        exportLabel: null,
        disabled: () => false
      };
    };
  }
  $onInit() {
  }
  logicalDateChanged() {
    this.odataController.unselectAll();
    this.odataController.options.$filter = this.getODataFilter();
    this.odataController.refresh();
  }
  download(item, target, ruleSet, message) {
    const account = this.proService.accounts.find((x) => x.id === item.ownerId);
    if (!account) {
      console.error("Account id not found: " + item.ownerId || "null/empty");
      return Promise.resolve(null);
    }
    return this.proService.getJSONFor(item.ownerId, `/v03/api/reports/data/accounting/${encodeURIComponent(target)}/${item.id}${ruleSet ? "?ruleSet=" + encodeURIComponent(ruleSet) : ""}`).then((data) => {
      const wfEvent = {
        type: "PartnerMessageClosed",
        ui: "success",
        message
      };
      return this.proService.postJSONFor(item.ownerId, `${this.baseUrl}/${item.id}/workflows`, wfEvent).then(() => {
        this.setWorkflowEvent(item, wfEvent);
        return data;
      });
    });
  }
  setWorkflowEvent(item, wfEvent) {
    item.flags = (item.flags || []).filter((x) => x !== wfEvent.type);
    item.messages = (item.messages || []).filter((x) => !x.startsWith(wfEvent.type));
    item.flags.push(wfEvent.type);
    item.messages.push(`${wfEvent.type} (Ui${wfEvent.ui}): ${wfEvent.message} ()`);
  }
}
AccountingReportProController.$inject = [
  "ProService"
];
